/** Personal parameters a call link can carry. GTM and the Meta pixel read the
 *  page address, so these come off it before the brand container loads. */
export const CALL_PERSONAL_PARAMS = ['at', 'ee_r', 'ee_vid'] as const;

/** Splits a query string into the personal link token (`at`) and the same
 *  query with every personal parameter removed. Pure, so it is testable. */
export function splitCallSearch(search: string): { at: string | null; cleanSearch: string } {
  const params = new URLSearchParams(search);
  const at = params.get('at');
  for (const k of CALL_PERSONAL_PARAMS) params.delete(k);
  const qs = params.toString();
  return { at, cleanSearch: qs ? `?${qs}` : '' };
}

/** A page address safe to keep as a landing page: the call link's personal
 *  parameters and any `email` come off (mct_56230f53-ca5 review). The root
 *  attribution hydrator runs before a call page strips its own address, so
 *  without this a reminder link's `at` token sat in the 90-day first-touch
 *  cookie and in submission_attribution.first_landing_page_uri. */
export function stripPersonalParams(href: string): string {
  try {
    const u = new URL(href);
    for (const k of CALL_PERSONAL_PARAMS) u.searchParams.delete(k);
    u.searchParams.delete('email');
    // The Free tier's claim link: its `t` is the person's seat (mct_b5801ee6-7de).
    if (u.pathname.replace(/\/+$/, '') === '/claim-your-seat') u.searchParams.delete('t');
    // A lead magnet's access link: its `t` names the person (mct_cebd6a68-c62).
    if (/^\/m\/[^/]+\/get$/.test(u.pathname.replace(/\/+$/, ''))) u.searchParams.delete('t');
    return u.toString();
  } catch {
    return href.split('?')[0];
  }
}
